"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const Env_1 = require("../../utils/tsUtils/Env");
const applicationService_1 = require("./service/applicationService");
exports.fetch = (0, toolkit_1.createAsyncThunk)("application/fetch", (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const applicationService = new applicationService_1.ApplicationService(Env_1.APIPATHENV);
        const response = yield applicationService.getApplicationList(fetchPayload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("application/create", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const applicationService = new applicationService_1.ApplicationService(Env_1.APIPATHENV);
        const response = yield applicationService.createApplication(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("application/update", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const applicationService = new applicationService_1.ApplicationService(Env_1.APIPATHENV);
        const response = yield applicationService.updateApplication(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
